export const ru = {
    'block-description':
        'Так ваше объявление увидят пользователи. Чем больше полей вы заполните, тем больше мест размещения вы сможете занять.',
    'block-title': 'Предпросмотр объявления',
    'go-to-link-btn': 'Перейти по ссылке',
    'play-btn': 'Смотреть видео',
    'play-btn-audio': 'Слушать аудио',
    'play-btn-common': 'Воспроизвести',
    'play-btn-video': 'Смотреть видео'
};
